// extracted by mini-css-extract-plugin
export default {"body":"footer_payment_body__KUOS9","btn_lg":"footer_payment_btn_lg__xAa5i","text-right":"footer_payment_text-right__Gvtuv","text-center":"footer_payment_text-center__BBjAH"};